import Ajax from './Ajax.js'

const ForestManagementContract = {
  getForestManagementContracts: (id = null) => {
    let uri = id !== null
      ? '/forest-management-contracts' + '/' + id
      : '/forest-management-contracts'
    return Ajax.get(uri)
  },

  postForestManagementContracts: (params) => {
    const payload = params && params.data ? params : {
      data: {
        area: params.area,
        document: params.document,
        status: params.status,
        signedDate: params.signedDate || params.signed_date,
        validFrom: params.validFrom || params.valid_from,
        validUntil: params.validUntil || params.valid_until
      }
    }
    return Ajax.post('/forest-management-contracts', payload)
  },

  putForestManagementContracts: (params) => {
    const id = params.id
    const data = { ...params }
    delete data.id
    const payload = params && params.data ? params : { data }
    return Ajax.put('/forest-management-contracts/' + id, payload)
  }
}

export default ForestManagementContract
